import './index.css';

import {
  AllContestListHeader,
  ContestFilter,
  ContestCard,
  ContestSortingHeader,
  ContestShare
} from '../../component';

import DefaultContainer from '../../../container/default_container';
import FantasyHeader from '../../../component/fantasy_header';

const AllContestListWeb = ({
  allContestList,
  onUpdateChallenge,
  defaultSort,
  onPressFilter,
  contestCategory,
  totalChallenges,
  onPressCard,
  onPressShare,
  matchStatus,
  gameState,
  totalTeamsCount,
  matchItem,
  matchDelayed,
  gameType,
  onApplyFilter,
  onClearFilter,
  contestFilterVisible,
  onPressFilterDismiss,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  onCalledDeadline
}: any) => {
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="all_contest_list_wrapper">
        <div className="all_contest_list_primary_container ">
          <FantasyHeader
            matchItem={matchItem}
            onCalledDeadline={onCalledDeadline}
            gameType={gameType}
          />
          <div className="allContestList__contestSortingHeader__web">
            <ContestSortingHeader
              challenges={allContestList}
              onUpdateChallenge={onUpdateChallenge}
              defaultSort={defaultSort}
              onPressFilter={onPressFilter}
              isAllContestList={true}
            />
          </div>
        </div>
        {/* <div style={{ height: '20%' }}> */}
        <AllContestListHeader contestCategory={contestCategory} totalChallenges={totalChallenges} />
        {/* </div> */}
        <div className="all_contest_list_card_wrapper">
          {allContestList.map((item: any) => (
            <ContestCard
              key={item._id}
              contest={item}
              onPressCard={() => onPressCard(item)}
              onPressShare={() => onPressShare()}
              matchStatus={matchStatus}
              gameState={gameState}
              totalTeamsCount={totalTeamsCount}
              matchItem={matchItem}
              matchDelayed={matchDelayed}
              screenName={'ALL_CONTEST'}
              gameType={gameType}
            />
          ))}
        </div>

        <ContestFilter
          onApplyFilter={onApplyFilter}
          onClearFilter={onClearFilter}
          visible={contestFilterVisible}
          onPressDismiss={onPressFilterDismiss}
        />
        <ContestShare
          link={contestLink}
          contestTitle={contestTitle}
          visible={contestShare}
          onPressDismiss={onPressShareModalDismiss}
        />
      </div>
    </DefaultContainer>
  );
};
export default AllContestListWeb;
